module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"searchInImpact":"Search KPIs in the ImpactNexus database"},"de":{"searchInImpact":"KPIs in der ImpactNexus Datenbank suchen"}}')
  delete Component.options._Ctor
}
